import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[[(!_vm.$route.meta.hideHeader)?_c('Header'):_vm._e(),_c(VMain,[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }